var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "container content-padding" },
    [
      _vm._m(0),
      _vm._v(" "),
      _vm.orderReport
        ? _c("div", { staticClass: "row mt-3" }, [
            _c("div", { staticClass: "col-md-6 col-12" }, [
              _c("div", { staticClass: "card" }, [
                _c("div", { staticClass: "card-header" }, [
                  _c("span", { staticClass: "font-weight-bold" }, [
                    _vm._v("วันที่ใช้บริการ")
                  ]),
                  _vm._v(" "),
                  _vm.orderReport.order_date
                    ? _c("span", [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm._f("prettyDate")(_vm.orderReport.order_date)
                            ) +
                            " "
                        )
                      ])
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c("ul", { staticClass: "list-group list-group-flush" }, [
                  _c(
                    "li",
                    { staticClass: "list-group-item" },
                    [
                      _c("span", { staticClass: "font-weight-bold" }, [
                        _vm._v("REF ID:")
                      ]),
                      _vm._v(" "),
                      _vm.orderReport.credit_invoice
                        ? [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm.orderReport.credit_invoice.reference
                                ) +
                                "\n            "
                            )
                          ]
                        : _vm._e()
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c("li", { staticClass: "list-group-item" }, [
                    _c("span", { staticClass: "font-weight-bold" }, [
                      _vm._v("BOOKING ID:")
                    ]),
                    _vm._v(" " + _vm._s(_vm.orderReport.order_code))
                  ]),
                  _vm._v(" "),
                  _c("li", { staticClass: "list-group-item" }, [
                    _c("span", { staticClass: "font-weight-bold" }, [
                      _vm._v("ชื่อที่พัก:")
                    ]),
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.orderReport.user_place
                            ? _vm.orderReport.user_place.place_name
                            : ""
                        )
                    )
                  ]),
                  _vm._v(" "),
                  _c("li", { staticClass: "list-group-item" }, [
                    _c("span", { staticClass: "font-weight-bold" }, [
                      _vm._v("ที่อยู่ที่พัก:")
                    ]),
                    _vm._v(" "),
                    _vm.orderReport.user_place &&
                    _vm.orderReport.user_place.address
                      ? _c("span", [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.orderReport.user_place.address) +
                              "\n          "
                          )
                        ])
                      : _vm._e()
                  ])
                ])
              ])
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-12" }, [
          _c("div", { staticClass: "card" }, [
            _c("div", { staticClass: "card-header" }, [
              _vm._v("\n          รูปภาพสถานที่\n        ")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "card-body pt-0" }, [
              _c(
                "div",
                { staticClass: "row" },
                _vm._l(_vm.filterByPhotoType(1), function(photo, index) {
                  return _c("div", { key: index, staticClass: "col-md-3" }, [
                    _c("div", { staticClass: "mt-3" }, [
                      _c("img", {
                        staticClass: "img-fluid",
                        staticStyle: { cursor: "pointer" },
                        attrs: { src: photo.image_xl, alt: "" },
                        on: {
                          click: function($event) {
                            return _vm.openGallery(index, 1)
                          }
                        }
                      })
                    ])
                  ])
                }),
                0
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-12" }, [
          _c("div", { staticClass: "card" }, [
            _c("div", { staticClass: "card-header" }, [
              _vm._v("\n          รูปภาพก่อนทำความสะอาด\n        ")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "card-body pt-0" }, [
              _c(
                "div",
                { staticClass: "row" },
                _vm._l(_vm.filterByPhotoType(2), function(photo, index) {
                  return _c("div", { key: index, staticClass: "col-md-3" }, [
                    _c("div", { staticClass: "mt-3" }, [
                      _c("img", {
                        staticClass: "img-fluid",
                        staticStyle: { cursor: "pointer" },
                        attrs: { src: photo.image_xl, alt: "" },
                        on: {
                          click: function($event) {
                            return _vm.openGallery(index, 2)
                          }
                        }
                      })
                    ])
                  ])
                }),
                0
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-12" }, [
          _c("div", { staticClass: "card" }, [
            _c("div", { staticClass: "card-header" }, [
              _vm._v("\n          รูปภาพหลังทำความสะอาด\n        ")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "card-body pt-0" }, [
              _c(
                "div",
                { staticClass: "row" },
                _vm._l(_vm.filterByPhotoType(3), function(photo, index) {
                  return _c("div", { key: index, staticClass: "col-md-3" }, [
                    _c("div", { staticClass: "mt-3" }, [
                      _c("img", {
                        staticClass: "img-fluid",
                        staticStyle: { cursor: "pointer" },
                        attrs: { src: photo.image_xl, alt: "" },
                        on: {
                          click: function($event) {
                            return _vm.openGallery(index, 3)
                          }
                        }
                      })
                    ])
                  ])
                }),
                0
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-12" }, [
          _c("div", { staticClass: "card" }, [
            _c("div", { staticClass: "card-header" }, [
              _vm._v("\n          เอกสารส่งมอบงาน\n        ")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "card-body" }, [
              _vm.orderReport.image_signature
                ? _c("div", [
                    _c("img", {
                      staticClass: "img-fluid",
                      attrs: { src: _vm.orderReport.image_signature, alt: "" }
                    })
                  ])
                : _vm._e()
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("Tinybox", {
        attrs: {
          images: _vm._.map(_vm.filterByPhotoType(_vm.photoTypeId), "image_xl"),
          loop: "",
          "no-thumbs": ""
        },
        model: {
          value: _vm.galleryIndex,
          callback: function($$v) {
            _vm.galleryIndex = $$v
          },
          expression: "galleryIndex"
        }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-12 text-center" }, [
        _c("span", { staticClass: "h5" }, [
          _vm._v("รูปภาพการให้บริการ และ เอกสารรับมอบงาน")
        ])
      ])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2c575828", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c575828","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/partner/BookingPartnerOrderReport.vue
// module id = 2358
// module chunks = 0